import { render, staticRenderFns } from "./IS-quality-widget.vue?vue&type=template&id=710c0144"
import script from "./IS-quality-widget.vue?vue&type=script&lang=js"
export * from "./IS-quality-widget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports